<template>
 <div>
  <figure>
   <img :src="picture" />
  </figure>
  <h1 v-if="title" class="logo">{{title}}</h1>
 </div>
</template>
<script>
 export default {
  props:["title","picture"]
 }
</script>
<style lang="scss" scoped>
div{
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 padding: 10px;
}
figure{
 margin: 0;
 border-radius: 50%;
 border: 5px solid #FFF;
 display: inline-block;
 width: 150px;
 height: 150px;
 overflow: hidden;
 position: relative;
}
img{
 width: auto;
 height: 100%;
 margin: 0 auto;
}
h1{
 text-align: center;
 margin:0;
}
//mobile
@media screen and (max-width:750px){
 figure{
  width:100px;
  height:100px;
 }
}
</style>